import { gql } from '@apollo/client';

export const UPDATE_AGENCY = gql`
  mutation UpdateAgency($input: AgencyInput!) {
    updateAgency(input: $input) {
      id
      name
      logo
      description
      address
      phone
      email
      website
      facebook
      instagram
      tiktok
      firstTitle
      secondTitle
      imageCover
      theme {
        primaryColor
        secondaryColor
        accentColor
        textColor
        backgroundColor
        heroTextColor
        headerStyle
        font
      }
      popularDestinations {
        id
        name
        image
        price
      }
      aboutImage
      yearsExperience
      expertise
      satisfiedTravelers
      prestations
    }
  }
`;

export const UPLOAD_FILE = gql`
  mutation UploadFile($file: String!, $agencyName: String!, $fieldName: String!) {
    uploadFile(file: $file, agencyName: $agencyName, fieldName: $fieldName) {
      url
    }
  }
`; 